import { render, staticRenderFns } from "./CatalogMenuPage.vue?vue&type=template&id=4e2fd8a2&scoped=true&"
import script from "./CatalogMenuPage.vue?vue&type=script&lang=js&"
export * from "./CatalogMenuPage.vue?vue&type=script&lang=js&"
import style0 from "./CatalogMenuPage.vue?vue&type=style&index=0&id=4e2fd8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fd8a2",
  null
  
)

export default component.exports